<div class="wrapper flex flex-col">
  <!-- <div class="header">
    <div class="back" (click)="jumpBack()">
      <i nz-icon nzType="left" nzTheme="outline"></i>
    </div>
    <div class="name">
      重复的房客
      {{ "order.similar_guest" | translate }}
    </div>
    <div></div>
  </div> -->
  <div class="guests flex-1 overflow-y-auto -mt-[30px]">
    <div class="guest" *ngFor="let guest of guestList">
      <div class="guest-name">
        <span class="name">{{ guest?.name }}</span>
        <div *ngIf="guest?.gender === 1 || guest?.gender === 2">
          <img class="gender" [src]="guest?.gender === 1 ? '/assets/guest/male.png' : '/assets/guest/female.png'" />
        </div>
      </div>
      <div class="labels" *ngIf="guest?.client_tags.length > 0">
        <div class="label" *ngFor="let label of guest?.client_tags" [style.background]="label?.color">
          {{ label?.name }}
        </div>
      </div>
      <div class="guest-info">
        <div class="guest-item" *ngIf="showItem(guest?.phone)">
          <div class="title">
            <!-- 手机： -->
            {{ 'order.phone' | translate }}
          </div>
          <div class="content">{{ guest?.phone }}</div>
        </div>
        <div class="guest-item" *ngIf="showItem(guest?.email)">
          <div class="title">
            <!-- 邮箱： -->
            {{ 'order.email' | translate }}
          </div>
          <div class="content">{{ guest?.email }}</div>
        </div>
        <div class="guest-item" *ngIf="showItem(guest?.id_number)">
          <div class="title">
            <!-- 证件： -->
            {{ 'order.certificate' | translate }}
          </div>
          <div class="content">
            <span>{{ guest?.id_type | credential }} {{ guest?.id_number }}</span>
            <span
              class="pics"
              (click)="showCredentials(guest?.client_credential)"
              *ngIf="guest?.client_credential?.length > 0"
            >
              <img src="/assets/icon/attachment.png" />
              <span class="number">{{ guest?.client_credential?.length }}</span>
            </span>
          </div>
        </div>
        <div class="guest-item" *ngIf="showItem(guest?.consumer_info?.last_checkin_time)">
          <div class="title">
            <!-- 上次入住： -->
            {{ 'order.last_checkin' | translate }}
          </div>
          <div class="content">
            <span>
              {{ guest?.consumer_info?.last_checkin_time | dateformat : ['YMD'] }}
            </span>
            <span style="padding-left: 5px">
              {{
                (guest?.consumer_info?.checkin_times === 1
                  ? 'order.checkin_times_single'
                  : 'order.checkin_times_repeatedly'
                ) | translate : { i: guest?.consumer_info?.checkin_times }
              }}
            </span>
          </div>
        </div>
        <div class="guest-item" *ngIf="guest?.consumer_info?.cumulative_consumer !== 0">
          <div class="title">
            <!-- 累计消费： -->
            {{ 'order.cumulative_consumption' | translate }}
          </div>
          <div class="content">
            <span>{{ guest?.consumer_info?.currency_type }}</span>
            <span style="padding-left: 5px">{{ guest?.consumer_info?.cumulative_consumer }}</span>
          </div>
        </div>
      </div>

      <button nz-button nzType="primary" class="merge" (click)="merge(guest.id)">
        <!-- 合并 -->
        {{ 'order.merge' | translate }}
      </button>
    </div>
  </div>
  <div class="footer">
    <button nz-button nzSize="large" (click)="closePannel()">
      {{ 'word.close' | translate }}
    </button>
  </div>
</div>
